import { defineComponent as _defineComponent } from 'vue'
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import { indexedWidgetDefinitions } from '@/utils/misc';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { dateRangeToDateStrings } from '@/utils/dates';
import { computed, ref, watch } from 'vue';
import { CompositeWidgetDefinition } from '@/models/Charts/compositeWidgetDefinition';


export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  props: {
    deviceId: null,
    dateRange: null,
    dateGrouping: null
  },
  setup(__props: any) {

const props = __props as {
  deviceId: string;
  dateRange: [Date, Date];
  dateGrouping: FilterTimeAxisSpanEnum;
};



const gridLayout = availableDashboardLayouts[DashboardLayout.TwoByThree];

const stringDateRange = computed<[string, string]>(() =>
  dateRangeToDateStrings(props.dateRange),
);

const widgetDefinitions = ref<WidgetDefinition[]>(
  indexedWidgetDefinitions(
    [
      WidgetEnum.TechnologyOverviewCuttingHoursTimeline,
      WidgetEnum.TechnologyOverviewLaserConsumptionTimeline,
      WidgetEnum.TechnologyOverviewDrawerCycleTimes,
      WidgetEnum.TechnologyLaserPowerUtilizationTimes,
      WidgetEnum.TechnologyOverviewSscFigures,
      WidgetEnum.CareEventsByModule,
    ].map(
      (widget) =>
        new WidgetDefinition(
          widget,
          props.deviceId,
          stringDateRange.value,
          [],
          undefined,
          props.dateGrouping,
        ),
    ),
  ),
);

function updateWidgetDefinition(
  index: number,
  widgetDefinition: WidgetDefinition | CompositeWidgetDefinition,
) {
  widgetDefinitions.value[index] = widgetDefinition as WidgetDefinition;
}

watch(
  () => [props.deviceId, props.dateRange, props.dateGrouping],
  () => {
    widgetDefinitions.value = widgetDefinitions.value.map((widgetDefinition) =>
      widgetDefinition.getCopy({
        deviceId: props.deviceId,
        timeFilter: stringDateRange.value,
        axisSpan: props.dateGrouping,
      }),
    );
  },
);

return { __sfc: true,props, gridLayout, stringDateRange, widgetDefinitions, updateWidgetDefinition, WidgetContainer, LayoutGrid }
}

})